module.exports = __webpack_public_path__ + "img/team7.33bb7c54.jpg";